import styled from "styled-components";

export const ExternalLinkCloseButtonWrapperDefaultBox = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -14px;
    right: -14px;
    padding: 4px;
    color: ${props => props.theme.colors.textLight};
    background-color: ${props => props.theme.colors.background};
    border: 1px solid ${props => props.theme.colors.backgroundContrast};
    border-radius: 50%;
    cursor: pointer;
`

